export default class LinkTpClientToClientData {
  constructor(bravoClientId) {
    this.TpClientLinkId = 0;
    this.BravoClientId = bravoClientId;
    this.ThirdPartyClientId = '';
    this.ThirdPartySource = '';
    this.NameDifferenceApproved = false;
    this.ApprovationNeeded = false;
  }
}
